/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.viewmodel

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import systems.frictionless.impulse.model.AuthenticatedUser
import systems.frictionless.impulse.rest.client.RestClient
import systems.frictionless.impulse.rest.client.model.RestResponse
import systems.frictionless.impulse.rest.model.Assessment
import systems.frictionless.impulse.rest.model.Insight

class InsightsViewModel(
    val authenticatedUser: AuthenticatedUser,
    val assessment: Assessment,
    val restClient: RestClient
) {
    private val mutableState =
        MutableStateFlow<NetworkViewModelState<Unit, Insight, Insight>>(NetworkViewModelState.Idle())
    val state: StateFlow<NetworkViewModelState<Unit, Insight, Insight>> = mutableState

    fun loadInsights(inScope: CoroutineScope) {
        require(state.value is NetworkViewModelState.Idle<*, *, *> || state.value is NetworkViewModelState.Failure<*, *, *>)
        mutableState.tryEmit(NetworkViewModelState.Busy())

        inScope.launch {
            when (val restResponse = restClient.getInsights(authenticatedUser.authentication, assessment)) {
                is RestResponse.Success -> {
                    mutableState.tryEmit(NetworkViewModelState.Complete(restResponse.result))
                }
                is RestResponse.Failure -> {
                    mutableState.tryEmit(NetworkViewModelState.Failure(Unit, restResponse))
                }
            }
        }
    }
}
